import styles from '../styles/QuemSomos.module.css'

export default function QuemSomos() {
  return (
    <section style={{ background: 'var(--dark-gray)' }}>
      <h2 className={styles['section-title']}>Quem Somos</h2>

      <div className={styles['advogados-container']}>
        <div
          className={`${styles['advogado-card']} ${styles['advogado-left']}`}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-10px)';
            e.currentTarget.style.boxShadow = '0 20px 40px rgba(var(--accent-rgb), 0.3)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.3)';
          }}
        >
          <div className={styles['image-container']}>
            <img 
              src="/assets/Fotos/Maike.jpg" 
              alt="Advogado Maike Ramos" 
              className={styles['advogado-img']}
            />
          </div>
          
          <div className={styles['info-overlay']}>
            <h3>Maike Ramos Pinheiro de Almeida</h3>
            <p>OAB/SP 472.586</p>
          </div>
        </div>

        <div className={`${styles['quote-container']} ${styles['quote-center']}`}>
          <p>
            Advogados com vasta experiência na atuação trabalhista, atendendo clientes em todo o Brasil. 
            Nossos profissionais se destacam pelo amplo conhecimento técnico jurídico para entender e 
            buscar o melhor para os nossos clientes.
            <br /><br />
            Acreditamos que cada cliente é único, e por isso oferecemos um atendimento personalizado 
            focado na resolução dos problemas de forma rápida, ética e profissional.
          </p>
        </div>

        <div
          className={`${styles['advogado-card']} ${styles['advogado-right']}`}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-10px)';
            e.currentTarget.style.boxShadow = '0 20px 40px rgba(var(--accent-rgb), 0.3)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.3)';
          }}
        >
          <div className={styles['image-container']}>
            <img 
              src="/assets/Fotos/Paulo.jpg" 
              alt="Advogado Paulo Márcio" 
              className={styles['advogado-img']}
            />
          </div>
          <div className={styles['info-overlay']}>
            <h3>Paulo Márcio Ferreira da Silva</h3>
            <p>OAB/SP 477.760</p>
          </div>
        </div>
      </div>
    </section>
  )
}